import { useAuthStore } from '@/stores/userStore';
import * as apiService from '@/services/apiService.js';
import AddRssNode from './AddRssNode.vue';

export default {
  name: "AdminDashboard",
  components: {
    AddRssNode
  },
  data() {
    return {
      userName: "",
      rssNodes: [],  // rssNodes 初始为空数组
      currentEntity: {},
      isModalOpen: false,
      isEditing: false,
      selectedRssNode: null,
      statistics: [
        { metric: 'Total Users', value: 150 },
        { metric: 'Active Sessions', value: 42 },
        { metric: 'New Signups', value: 10 },
      ],
      isLoading: false,
      showExportDialog: false,
      isExporting: false,
      exportForm: {
        dateOperator: '=',
        date: new Date().toISOString().split('T')[0],
        startDate: '',
        endDate: '',
        rssNodeId: '',
        limit: ''
      },
      // Pipeline Monitor
      pipelineStatus: null,
      pipelineLoading: false,
      recentScoredItems: []
    };
  },
  computed: {
  },
  watch: {
    'exportForm.dateOperator': {
      handler(newVal) {
        if (newVal === 'between') {
          // 设置默认日期范围：前三天到今天
          const today = new Date()
          const threeDaysAgo = new Date(today)
          threeDaysAgo.setDate(today.getDate() - 3)

          this.exportForm.startDate = threeDaysAgo.toISOString().split('T')[0]
          this.exportForm.endDate = today.toISOString().split('T')[0]
        } else {
          // 重置为单个日期模式
          this.exportForm.startDate = ''
          this.exportForm.endDate = ''
          this.exportForm.date = new Date().toISOString().split('T')[0]
        }
      },
      immediate: true
    }
  },
  mounted() {
    try {
      const authStore = useAuthStore();
      if (!authStore.isAuthenticated) {
        this.logexit();
        return;
      }
      // 同步用户名
      this.userName = authStore.username || "Rss user";
      this.setLoading(true); // 启动加载状态
      apiService.LConn(authStore.token, this.setLoading)
        .then(response => {
          if (response.checked === 1) {
            console.log('LConn:', response);
            return apiService.AdminNodes(this.setLoading, authStore.token); // 返回 Promise
          } else {
            console.log('No valid token or username found, logging out.');
            this.logexit();
          }
        })
        .then(rssNodesResponse => {
          if (rssNodesResponse) {
            this.rssNodes = rssNodesResponse; // 赋值 rssNodes
            console.log('Fetched RssNodes:', this.rssNodes);
            // Auto-refresh pipeline status
            this.refreshPipelineStatus();
          }
        })
        .catch(error => {
          console.error('Error during API call:', error);
          this.logexit();
        })
        .finally(() => {
          this.setLoading(false); // 关闭加载状态
        });
    } catch (error) {
      this.logexit();
    }
  },
  methods: {
    async refreshPipelineStatus() {
      this.pipelineLoading = true;
      try {
        const API_BASE = process.env.VUE_APP_API_BASE_URL || '';
        const response = await fetch(`${API_BASE}/TestPipeline/status`);
        if (response.ok) {
          this.pipelineStatus = await response.json();
        }
        // Fetch recent scored items
        const recentResponse = await fetch(`${API_BASE}/TestPipeline/recent-scored?limit=10`);
        if (recentResponse.ok) {
          this.recentScoredItems = await recentResponse.json();
        }
      } catch (error) {
        console.error('Failed to fetch pipeline status:', error);
      } finally {
        this.pipelineLoading = false;
      }
    },
    getStatusLabel(status) {
      const labels = {
        0: '待筛选',
        10: '待抓取',
        20: '待评分',
        99: '低质量',
        100: '已完成',
        '-1': '已忽略'
      };
      return labels[status] || status;
    },
    openAddModal() {
      this.isModalOpen = true;
      this.isEditing = false;
      this.currentEntity = {};
    },
    editRssNode(node) {
      this.isEditing = true;
      this.currentEntity = { ...node }; // Clone the node for editing
      this.isModalOpen = true;
    },
    addRssNode(newNode) {
      this.rssNodes.push(newNode); // Add new node
      this.saveNode(newNode);
    },
    updateRssNode(updatedNode) {
      const index = this.rssNodes.findIndex(node => node.id === updatedNode.id);
      if (index !== -1) {
        this.rssNodes.splice(index, 1, updatedNode);
        this.saveNode(updatedNode);
      }
    },
    closeModal() {
      this.isModalOpen = false;
      this.isEditing = false;
      this.currentEntity = {};
    },
    submitForm() {
      if (this.isEditing) {
        // 编辑模式
        const index = this.rssNodes.findIndex(node => node.id === this.form.id);
        if (index !== -1) {
          this.$set(this.rssNodes, index, { ...this.form });
        }
      } else {
        // 新增模式
        const newNode = { ...this.form, id: Date.now() }; // 使用当前时间戳生成 ID
        this.rssNodes.push(newNode);
      }
      this.closeModal();
    },
    async deleteEntry(id) {
      try {
        const authStore = useAuthStore();
        if (!authStore.isAuthenticated) {
          this.logexit();
          return;
        }

        await apiService.DelNode(id, this.setLoading, authStore.token);
        this.rssNodes = this.rssNodes.filter(node => node.id !== id);
        console.log('Node deleted successfully!');
      } catch (error) {
        console.error('Failed to delete node:', error);
        if (error.status === 401) {
          // 保存当前页面状态
          localStorage.setItem('redirectAfterLogin', '/admin');
          this.logexit();
        }
      }
    },
    async saveNode(node) {
      try {
        const authStore = useAuthStore();
        if (!authStore.isAuthenticated) {
          this.logexit();
          return;
        }

        // 确保包含 _id 字段，如果为 null 则设为 "-1"
        const nodeData = {
          ...node,
          _id: node.id || "-1" // 使用 id 作为 _id，如果为 null 则设为 "-1"
        }
        await apiService.addOrUpdateNode(nodeData, this.setLoading, authStore.token);
        console.log('Node saved successfully!');
      } catch (error) {
        console.error('Failed to save node:', error);
        if (error.status === 401) {
          // 保存当前页面状态
          localStorage.setItem('redirectAfterLogin', '/admin');
          this.logexit();
        }
      }
    },
    logexit() {
      const userStore = useAuthStore();
      userStore.setlogout();
      this.$router.push('/login'); // 重定向到登录页
    },
    setLoading(loading) {
      this.isLoading = loading;
    },
    async exportArticles() {
      try {
        this.isExporting = true

        const authStore = useAuthStore();
        if (!authStore.isAuthenticated) {
          this.logexit();
          return;
        }

        // 构建请求参数
        const params = {}

        // 处理日期条件
        if (this.exportForm.dateOperator === 'between') {
          // 只有在选择时间段且未指定具体日期时才设置默认值
          if (!this.exportForm.startDate || !this.exportForm.endDate) {
            // 设置默认日期范围：前三天到今天
            const today = new Date()
            const threeDaysAgo = new Date(today)
            threeDaysAgo.setDate(today.getDate() - 3)

            params.startDate = threeDaysAgo.toISOString().split('T')[0]
            params.endDate = today.toISOString().split('T')[0]
          } else {
            params.startDate = this.exportForm.startDate
            params.endDate = this.exportForm.endDate
          }
          params.dateOperator = 'between'
        } else {
          // 其他情况必须指定日期
          if (!this.exportForm.date) {
            throw new Error('请选择日期')
          }
          params.date = this.exportForm.date
          params.dateOperator = this.exportForm.dateOperator
        }

        // 添加其他参数
        if (this.exportForm.rssNodeId) {
          params.rssNodeId = this.exportForm.rssNodeId
        }
        if (this.exportForm.limit) {
          params.limit = parseInt(this.exportForm.limit)
        }

        console.log('Export params:', params) // 添加日志

        // 调用导出API
        const response = await apiService.exportArticles(params, (loading) => {
          this.isExporting = loading
        }, authStore.token)

        // 添加 UTF-8 BOM
        const BOM = '\uFEFF'
        const contentWithBOM = BOM + response

        // 创建下载链接，使用 UTF-8 编码
        const blob = new Blob([contentWithBOM], {
          type: 'text/csv;charset=utf-8'
        })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = `feeds_export_${new Date().toISOString().split('T')[0]}.csv`
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(a)

        this.showExportDialog = false
      } catch (error) {
        console.error('导出失败:', error)
        alert('导出失败: ' + error.message)
      } finally {
        this.isExporting = false
      }
    },
    safeNodes() {
      return Array.isArray(this.rssNodes)
        ? this.rssNodes.filter(n => n && n.id !== undefined && n.id !== null && n.id !== '')
        : [];
    }
  },
};
